// extracted by mini-css-extract-plugin
export default {"container":"SmallSpinner_container__3IZab","spinner":"SmallSpinner_spinner__T1PLf"};